import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatCurrency, formatInteger } from '../calculator-utils';

import styles from '../../shared/calculator-results.module.scss';
const { legend_container, legend_item, legend_label, legend_color, legend_value } = styles;

/**
 * Shared legend component for calculator results
 * Handles both colored (with dots) and simple text legends
 */
const CalculatorLegend = ({ items, condensed = false, hideVisual = false }) => {
  return (
    <div
      className={classNames(legend_container, {
        condensed: condensed,
        hide_visual: hideVisual
      })}
    >
      {items.map((item) => (
        <div key={item.label} className={legend_item}>
          <div className={legend_label}>
            {item.color && <div className={legend_color} style={{ backgroundColor: item.color }} />}
            {item.label}
          </div>
          <div className={legend_value}>
            {item.displayValue !== undefined
              ? item.displayValue
              : item.isInteger
                ? formatInteger(item.value)
                : item.suffix
                  ? `${formatCurrency(item.value)}${item.suffix}`
                  : formatCurrency(item.value)}
          </div>
        </div>
      ))}
    </div>
  );
};

CalculatorLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number,
      color: PropTypes.string, // Optional: color for the legend dot
      isInteger: PropTypes.bool, // Optional: format as integer instead of currency
      suffix: PropTypes.string, // Optional: text to append after value (e.g., "/month*")
      displayValue: PropTypes.string // Optional: custom display value (e.g., "N/A")
    })
  ).isRequired,
  condensed: PropTypes.bool,
  hideVisual: PropTypes.bool
};

export default CalculatorLegend;
